import React from 'react';

import styles from './base.module.scss';

interface BaseTemplateProps {
  children: React.ReactNode;
};

export const BaseTemplate: React.FC<BaseTemplateProps> = (props) => {
  return (
    <div className={styles['base-template']}>
      {props.children}
    </div>
  );
};
